import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(() => ({
  textInput: {
    '& .MuiInputBase-input': {
      // height: '44px',
      color: 'unset !important',
    },
  },
  label: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'black',
  },
  closeButton: {
    cursor: 'pointer',
    borderRadius: '50%',
    height: '28px',
    width: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: '#F7F7F7',
    },
  },
}), { name: 'RemitterDrawerStyles' });

export default useStyles;
